//import $ from 'jquery';
//import kendo from '@progress/kendo-ui';
localStorage.getItem('NG_TRANSLATE_LANG_KEY') === 'en' ? import('@/app/visit-management/theme/discountrule.scss') : import('@/app/visit-management/theme/discountrule-rtl.scss');
import localeEn from '@/app/visit-management/locales/en.json'
import localeAr from '@/app/visit-management/locales/ar.json'
//import { mapGetters } from 'vuex'
import { showPopupNotification } from '@/app/shared/grid-functionality/grid-functionality.js';

//loader
import Loader from '@/app/shared/layouts/components/loader/loader.vue';
import { mapMutations } from 'vuex'
import { EventBus as GlobalEventBus } from '@/app/shared/services/event-bus.js';

//confirmation
//import { getEligibilityRequestPurpose, getCheckEligibilityResult, getGetInsuranceInfoResult } from '@/app/visit-management/shared/visitManagement-enums.js';


export default {
    name: 'claim-nphies-cards',
    props: ['VisitNphiesStatus'],
    data() {
        return {
            suffix: 'claim-nphies-cards',
            EnglishLang: localStorage.getItem('NG_TRANSLATE_LANG_KEY') === 'en',
            hideNotification: 5000,
            imgUrl: '@/assets/svg/vm/',
            isLoading: false,
            ContractorStatementID: this.$route.query.ContractorStatementID,
        }
    },
    computed: {
        VisitNphiesStatusList() {
            if (!this.VisitNphiesStatus)
                return;

            return this.VisitNphiesStatus;
        },
        ContractorStatementSummary() {
            debugger;
            return this.$store.getters.getContractorStatementSummary;
        },
        SelectedStatementIds() {
            return this.$store.getters.getSelectedStatementIds;
        },
        SelectedNphiesStatusIds() {
            return this.$store.getters.getSelectedNphiesStatusIds;
        },
        BundleIdInputValue() {
            return this.$store.getters.getBundleIdInputValue;
        },
        IsFilterByBundleId() {
            return this.$store.getters.getIsFilterByBundleId;
        },
        IsSearchAndFilterBtnsDisabled() {
            return this.$store.getters.getIsSearchAndFilterBtnsDisabled;
        },
        ClaimStatusesDS() {
            debugger;
            return this.ContractorStatementSummary == null || this.ContractorStatementSummary.length == 0 ? this.VisitNphiesStatus : this.ContractorStatementSummary
        },
        filterBtnDisabled() {
            let isAllDisabled = true;

            if (this.ClaimStatusesDS == null)
                return;

            this.ClaimStatusesDS.forEach((item) => {
                if (item.IsSelected) {
                    isAllDisabled = false;
                }

            })

            return isAllDisabled || this.IsSearchAndFilterBtnsDisabled;
        },
    },
    watch: {

    },
    methods: {
        ...mapMutations(['setContractorStatementSummary', 'setSelectedNphiesStatusIds']),
        showPopupNotification,
        startLoading() {
            this.loadingCount += 1;
        },
        finishLoading() {
            this.loadingCount -= 1;
        },

        ImgSource(id) {
            let Item = this.ClaimStatusesDS.find(item => item.StatusId == id)
            console.log(Item.IconName, 'listaT')
            //  return Item.IsSelected ? `${require(`@/assets/svg/vm/${Item.IconNameSelected}.svg`)}`: `${require(`@/assets/svg/vm/${Item.IconName}.svg`)}`;
            return `${require(`@/assets/svg/vm/${Item.IconName}.svg`)}`;
        },
        cardSelectedClicked(id) {
            let Item = this.ClaimStatusesDS.find(item => item.StatusId == id)
            Item.IsSelected = !Item.IsSelected;

            let selectedNphieStatus = this.ClaimStatusesDS.filter(x => x.IsSelected);
            this.setSelectedNphiesStatusIds(selectedNphieStatus.map(s => s.StatusId));
        },

        SelectUnSelectedAllClicked(isSelect) {
            this.ClaimStatusesDS.forEach((item) => {
                item.IsSelected = isSelect
            })
            let selectedNphieStatus = this.ClaimStatusesDS.filter(x => x.IsSelected);
            this.setSelectedNphiesStatusIds(selectedNphieStatus.map(s => s.StatusId));
        },
        filterClickedBtn() {
            debugger;
            let params = {
                SelectedStatementIds: this.IsFilterByBundleId ? '' : this.SelectedStatementIds,
                SelectedNphiesStatusIds:  this.SelectedNphiesStatusIds,
                BundleId: this.IsFilterByBundleId ? this.BundleIdInputValue : '',
                ContractorStatementID : this.ContractorStatementID
            }

            GlobalEventBus.$emit('GetStatementsVisits', params);
        }

    },
    mounted() {
        this.popupNotificationWidget = this.$refs.popupNotification.kendoWidget();

        GlobalEventBus.$on("selectAllCards", () => {
            this.SelectUnSelectedAllClicked(true)
        })
    },
    created() {
        this.setContractorStatementSummary(this.VisitNphiesStatusList);

        let selectedNphieStatus = this.VisitNphiesStatusList.filter(x => x.IsSelected);
        this.setSelectedNphiesStatusIds(selectedNphieStatus.map(s => s.StatusId));
    },
    beforeDestroy() {
        GlobalEventBus.$off(`selectAllCards`);

    },
    components: {

        Loader,

    },
    i18n: {
        messages: {
            en: {
                ...localeEn
            },
            ar: {
                ...localeAr
            }
        },

    }

}